import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Settings, Printer, Receipt, ChevronRight } from 'lucide-react';

export function SettingsHub() {
  const navigate = useNavigate();

  const settingsOptions = [
    {
      id: 'general',
      title: 'Configuración general',
      description: 'Personaliza la aplicación a tu gusto',
      icon: Settings,
      onClick: () => navigate('/settings/general')
    },
    {
      id: 'printers',
      title: 'Impresoras',
      description: 'Gestiona tus impresoras térmicas',
      icon: Printer,
      onClick: () => navigate('/settings/printers')
    },
    {
      id: 'tickets',
      title: 'Tickets',
      description: 'Configura los formatos de tickets',
      icon: Receipt,
      onClick: () => navigate('/settings/tickets')
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="sticky top-0 bg-white dark:bg-gray-800 border-b dark:border-gray-700">
        <div className="flex items-center p-4">
          <div className="flex items-center gap-4">
            <button 
              onClick={() => navigate('/menu')}
              className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
            >
              <ArrowLeft className="w-5 h-5 dark:text-gray-200" />
            </button>
            <h1 className="text-2xl font-bold dark:text-white">Configuración</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4">
        {settingsOptions.map(option => {
          const Icon = option.icon;
          return (
            <button
              key={option.id}
              onClick={option.onClick}
              className="w-full bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 p-4 rounded-lg shadow-sm flex items-center justify-between group"
            >
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-700">
                  <Icon className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                </div>
                <div className="text-left">
                  <div className="font-medium dark:text-white">{option.title}</div>
                  <div className="text-sm text-gray-500 dark:text-gray-400">{option.description}</div>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-gray-600 dark:text-gray-500 dark:group-hover:text-gray-300" />
            </button>
          );
        })}
      </div>
    </div>
  );
} 